/*
 * Module for the contact information page
*/

rs.module("ui/content/account/contactinformation/index",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, addressListApi, emailListApi, phoneListApi) {

            // Hook up address list item click
            addressListApi.onItemClick(function (e, context) {
                unSelectOtherListItems(emailListApi, phoneListApi);
                loadDetail(addressListApi, context);
            });

            // Hook up email list item click
            emailListApi.onItemClick(function (e, context) {
                unSelectOtherListItems(addressListApi, phoneListApi);
                loadDetail(emailListApi, context);
            });

            // Hook up phone list item click
            phoneListApi.onItemClick(function (e, context) {
                unSelectOtherListItems(addressListApi, emailListApi);
                loadDetail(phoneListApi, context);
            });

            // Load the contact info detail
            function loadDetail(listApi, context) {

                listApi.detail.updateTitle(context.detailTitle);

                $.get(
                    context.detailLink,
                    {
                        entityKey: context.entityKey,
                    })
                    .done(function (html) {
                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            }

            // Load the new phone detail
            $.js(jsSelectors.addPhoneItem, { required: false }).on("click", function () {

                phoneListApi.detail.initializeDetail();
                phoneListApi.detail.updateTitle($(this).data("detailtitle"));
                unSelectOtherListItems(addressListApi, emailListApi, phoneListApi);
                $(this).addClass("_selected");

                $.get(
                    $(this).data("detaillink"),
                    {
                        entityKey: $(this).data("entitykey"),
                    })
                    .done(function (html) {
                        phoneListApi.detail.loadDetail(html);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        phoneListApi.detail.clearDetail();
                    });

            });

            // convenience function to unselect other list items
            function unSelectOtherListItems(...apis) {

                $.js(jsSelectors.addPhoneItem, { required: false }).removeClass("_selected");

                apis.forEach((api) => {
                    api.unSelectItems();
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);